import { isAfter, isBefore } from "date-fns";

import { getDateAfterNDays, getTimeLeftUntilEndDate } from "../utils";

interface useCompetitionDateValidationDataProps {
  startDate: string;
  endDate: string;
  deliveryCutoffDate: string;
}

export const useCompetitionDateValidationData = ({
  startDate,
  endDate,
  deliveryCutoffDate,
}: useCompetitionDateValidationDataProps) => {
  const today = new Date();

  const resultsAccessEndDate = getDateAfterNDays({
    inputDate: deliveryCutoffDate,
    daysToAdd: 7,
  });

  const isCompetitionPeriod =
    isAfter(today, new Date(startDate)) && isBefore(today, new Date(endDate));

  const isDeliveryGracePeriod =
    isAfter(today, new Date(startDate)) &&
    isBefore(today, new Date(deliveryCutoffDate));

  const isResultsAccessPeriod =
    isAfter(today, new Date(startDate)) &&
    isBefore(today, new Date(resultsAccessEndDate));

  return {
    isCompetitionPeriod,
    isDeliveryGracePeriod,
    isResultsAccessPeriod,
    isBeforeCompetitionStart: isBefore(today, new Date(startDate)),
    isCompetitionStarted: isAfter(today, new Date(startDate)),
    isCompetitionCompleted: isAfter(today, new Date(endDate)),
    ...getTimeLeftUntilEndDate({ endDate }),
  };
};
